import {
  Avatar,
  Box,
  Divider,
  Flex,
  Grid,
  GridItem,
  Image,
  Link,
  Portal,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../components/common/DashboardHeader";
import Loading from "../../components/common/Loading";
import { ViewUserBadges } from "../../components/trainee/badge/ViewBadgeModal";
import autostore from "../../img/autostories.svg";
import closeshot from "../../img/closeshot.png";
import empty from "../../img/emptystate1.svg";
import empty2 from "../../img/emptystate2.svg";
import engineering from "../../img/engring.png";
import school from "../../img/school.svg";
import workspace from "../../img/workspacepremium.svg";
import { IUserBadgeData } from "../../models/admin/badges/userBadge.model";
import { IAdvertisedCourses } from "../../models/advertisedcourse.model";
import { IUser } from "../../models/auth.model";
import { IGetEnrolment } from "../../models/course-enrolment.model";
import { ITraineeDashboard } from "../../models/dashboard/trainee-dashboard";
import BadgeService from "../../services/admin/badge.service";
import { getLocalUserProfile } from "../../services/auth.service";
import courseEnrolmentService from "../../services/course-enrolment.service";
import coursesService from "../../services/courses.service";
import userService from "../../services/user.service";
import courseRoutes from "../courses/courseRoutes";
import routes from "../routes";

//import 'react-calendar/dist/Calendar.css';
const Dashboard = () => {
  const navigate = useNavigate();
  const [regStatus, setRegStatus] = useState(Boolean);
  const [userProfile, setUserProfile] = useState<IUser | null>();
  const [loading, setLoading] = useState(true);
  const [advertisedCourses, setAdvertisedCourses] = useState<
    IAdvertisedCourses[]
  >([]);
  const [userBadges, setUserBadges] = useState<IUserBadgeData[]>([]);
  const [inProgress, setInProgress] = useState<IGetEnrolment[]>([]);
  const [date, setDate] = useState(new Date());
  const [isBadge, setIsBade] = useState(false);
  const [dashboard, setDashboard] = useState<ITraineeDashboard>();

  useEffect(() => {
    userService
      .getTraineeDashboard()
      .then((response) => {
        setDashboard(response.data);
      })
      .catch((err) => err);
  }, []);

  useEffect(() => {
    const completed = localStorage.getItem("completed");
    completed == "true" ? setRegStatus(true) : setRegStatus(false);
    const user = getLocalUserProfile();
    setUserProfile(user);

    if (user) {
      courseEnrolmentService
        .getEnroledCourses(user.id.toString())
        .then((response) => {
          const enrolledCourses = response.data.filter(
            (course) => course.status == 5 && course.payment.amountpaid > 0
          );
          setInProgress(enrolledCourses);
          setLoading(false);
        })
        .catch((err) => err);
      BadgeService.getUserBadges(user.id.toString())
        .then((response) => {
          setUserBadges(response.data);
          setLoading(false);
        })
        .catch((err) => err);
    }
    coursesService.getAdvertisedCourses().then((res) => {
      setAdvertisedCourses(res);
      setLoading(false);
    });
  }, []);

  const viewEachCourse = async (course_id: string) => {
    localStorage.setItem("eachCourseId", course_id);
    navigate(courseRoutes.CourseInformationLink(course_id));
  };

  const showBadge = () => {
    setIsBade(true);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <DashboardHeader />
          <Flex
            minHeight="100vh"
            height={"auto"}
            width={"100vw"}
            bg="#F9F8F8"
            pt="50px"
            pb={["80px", "80px", "100px", "120px"]}
            mx="auto"
            justifyContent={"center"}
          >
            <Box
              ml={["0px", "0px", "20px", "80px"]}
              mr={["0px", "0px", "10px", "30px"]}
              display={["none", "none", "block", "block"]}
              width={["0%", "0%", "35%", "30%"]}
            >
              <Flex
                mb="30px"
                flexDirection="column"
                // maxWidth="350px"
                width={["90%", "90%", "100%", "90%"]}
                height="350px"
                justifyContent="center"
                bg="white"
                boxShadow="md"
                rounded="lg"
              >
                <Avatar
                  mx="auto"
                  width="100px"
                  height="100px"
                  borderRadius="50px"
                  name={dashboard ? dashboard?.name : ""}
                ></Avatar>
                <Text mx="auto" fontSize="20px" fontWeight="500">
                  {dashboard?.name}
                </Text>
                <Text mx="auto" fontSize="13px" color="#9E9E9E" mb="20px">
                  TNE-
                  {dashboard
                    ? dashboard.code
                      ? dashboard.code
                      : "Nil"
                    : "Nil"}
                </Text>
                <Text
                  mx="auto"
                  fontSize="15px"
                  color={regStatus ? "#0CBC08" : "#EC3337"}
                  cursor="pointer"
                  onClick={() => navigate(routes.Registration)}
                >
                  Update Profile
                </Text>
              </Flex>

              <Box
                mb="30px"
                width={["90%", "90%", "100%", "90%"]}
                boxShadow="md"
                rounded="lg"
              >
                <Calendar onChange={setDate} value={date} />
              </Box>
              <Flex
                flexDirection="column"
                width={["90%", "90%", "100%", "90%"]}
                height="350px"
                pt="25px"
                bg="white"
                boxShadow="md"
                rounded="lg"
              >
                <Text mx="auto" pb="25px">
                  Upcoming Task
                </Text>
                <Box mx="auto" width={"90%"} minHeight="55px" bg="#F9F8F8">
                  <Text p="15px">Field work</Text>
                </Box>
              </Flex>
            </Box>

            <Box
              width={["100%", "100%", "65%", "70%"]}
              mx="auto"
              pl="1rem"
              pr={["1rem", "1rem", "1rem", "3rem"]}
            >
              <Grid
                bg="white"
                padding="1rem"
                gap="1rem"
                boxShadow="md"
                rounded="lg"
                mb="40px"
                templateColumns="repeat(5, auto)"
                justifyContent="space-around"
                height={"auto"}
              >
                <GridItem
                  gap="8px"
                  textAlign="center"
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={{
                    lg: "column",
                    md: "column",
                    sm: "column",
                    base: "column",
                  }}
                >
                  <Image
                    src={school}
                    margin="0 auto"
                    width={{
                      lg: "auto",
                      md: "auto",
                      sm: "25px",
                      base: "25px",
                    }}
                    height={{
                      lg: "50px",
                      md: "50px",
                      sm: "24px",
                      base: "24px",
                    }}
                  />
                  <Box>
                    <Text
                      fontSize={{
                        lg: "22px",
                        md: "20px",
                        sm: "16px",
                        base: "16px",
                      }}
                      color="black"
                      fontWeight="600"
                    >
                      {inProgress.length}
                    </Text>
                    <Text
                      fontSize={{
                        lg: "20px",
                        md: "17px",
                        sm: "12px",
                        base: "12px",
                      }}
                    >
                      Courses Enrolled
                    </Text>
                  </Box>
                </GridItem>
                <Divider color="gray.200" orientation="vertical" />
                <GridItem
                  gap="8px"
                  textAlign="center"
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={{
                    lg: "column",
                    md: "column",
                    sm: "column",
                    base: "column",
                  }}
                >
                  <Image
                    src={workspace}
                    margin="0 auto"
                    width={{
                      lg: "auto",
                      md: "auto",
                      sm: "25px",
                      base: "25px",
                    }}
                    height={{
                      lg: "50px",
                      md: "50px",
                      sm: "24px",
                      base: "24px",
                    }}
                  />
                  <Box>
                    <Text
                      fontSize={{
                        lg: "22px",
                        md: "20px",
                        sm: "16px",
                        base: "16px",
                      }}
                      color="black"
                      fontWeight="600"
                    >
                      {dashboard
                        ? dashboard.enrollments.length > 0
                          ? "1"
                          : "0"
                        : "0"}
                    </Text>
                    <Text
                      fontSize={{
                        lg: "20px",
                        md: "17px",
                        sm: "12px",
                        base: "12px",
                      }}
                    >
                      Current Courses
                    </Text>
                  </Box>
                </GridItem>
                <Divider color="gray.200" orientation="vertical" />
                <GridItem
                  gap="8px"
                  textAlign="center"
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={{
                    lg: "column",
                    md: "column",
                    sm: "column",
                    base: "column",
                  }}
                >
                  <Image
                    src={autostore}
                    margin="0 auto"
                    width={{
                      lg: "auto",
                      md: "auto",
                      sm: "25px",
                      base: "25px",
                    }}
                    height={{
                      lg: "50px",
                      md: "50px",
                      sm: "24px",
                      base: "24px",
                    }}
                  />
                  <Box
                    cursor={"pointer"}
                    onClick={() => {
                      showBadge();
                    }}
                  >
                    <Text
                      fontSize={{
                        lg: "22px",
                        md: "20px",
                        sm: "16px",
                        base: "16px",
                      }}
                      color="black"
                      fontWeight="600"
                    >
                      {userBadges.length}
                    </Text>
                    <Text
                      fontSize={{
                        lg: "20px",
                        md: "17px",
                        sm: "12px",
                        base: "12px",
                      }}
                    >
                      Badges Earned
                    </Text>
                  </Box>
                </GridItem>
              </Grid>

              <Box
                width="100%"
                bg="white"
                mb="40px"
                boxShadow="md"
                rounded="lg"
                mx={{ sm: "auto", base: "auto" }}
              >
                <Flex
                  mx="auto"
                  width="87%"
                  bg="white"
                  pb="12px"
                  pt="15px"
                  mb="12px"
                  borderBottom="2px solid"
                  borderColor="gray.200"
                  justifyContent="space-between"
                >
                  <Text fontSize="18px" fontWeight="500">
                    Current Courses
                  </Text>
                  <Link
                    fontWeight="500"
                    color="#EC3337"
                    fontSize="16px"
                    onClick={() => navigate(courseRoutes.mycourses)}
                  >
                    See All
                  </Link>
                </Flex>
                {inProgress.length > 0 ? (
                  inProgress.slice(0, 1).map((each, index) => (
                    <Flex
                      key={index}
                      mx="auto"
                      width="87%"
                      bg="white"
                      pb="1.6rem"
                      pt="0.5rem"
                      cursor="pointer"
                      justifyContent="space-between"
                      flexDirection={{
                        lg: "row",
                        md: "column",
                        sm: "column",
                        base: "column",
                      }}
                      onClick={() => viewEachCourse(each.course.uuid)}
                    >
                      <Box
                        width={{
                          lg: "47%",
                          md: "100%",
                          sm: "100%",
                          base: "100%",
                        }}
                      >
                        <Image
                          objectFit="contain"
                          width="100%"
                          height={["200px", "300px"]}
                          src={each.course?.cover_image || engineering}
                        />
                      </Box>
                      <Box
                        width={{
                          lg: "47%",
                          md: "100%%",
                          sm: "100%",
                          base: "100%",
                        }}
                      >
                        <Text
                          color="black"
                          fontSize={{
                            lg: "22px",
                            md: "20px",
                            sm: "18px",
                            base: "18px",
                          }}
                          mt={{
                            lg: "0px",
                            md: "10px",
                            sm: "12px",
                            base: "12px",
                          }}
                          fontWeight="600"
                          mb="21px"
                        >
                          {each.course.name}
                        </Text>
                        <Text
                          color="#9E9E9E"
                          fontSize={{
                            lg: "14px",
                            md: "13px",
                            sm: "12px",
                            base: "12px",
                          }}
                          fontWeight="400"
                          mb="21px"
                        >
                          {each.course.description
                            ? each.course.description.substring(0, 200)
                            : "Nil"}
                        </Text>
                        {/* <Progress
                          value={0}
                          size="sm"
                          colorScheme="red"
                          width="20rem"
                          borderRadius="0.5rem"
                          height="0.4rem"
                        /> */}
                      </Box>
                    </Flex>
                  ))
                ) : (
                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="12px"
                    pt="15px"
                    justifyContent="center"
                  >
                    <Box pb="1.4rem">
                      <Box mx="auto" width={"70px"} height="100px">
                        <Image src={empty} />
                      </Box>
                      <Text
                        textAlign="center"
                        fontWeight="600"
                        fontSize="30px"
                        color="#353535"
                      >
                        No Courses
                      </Text>
                      <Text color="#353535" textAlign="center" fontSize="14px">
                        Go to the available courses to enrol for a course
                      </Text>
                    </Box>
                  </Flex>
                )}
              </Box>
              <Box
                width="100%"
                bg="white"
                boxShadow="md"
                rounded="lg"
                mx={{ sm: "auto", base: "auto" }}
              >
                <Flex
                  mx="auto"
                  width="87%"
                  bg="white"
                  pb="12px"
                  pt="15px"
                  mb="36px"
                  borderBottom="2px solid"
                  borderColor="gray.200"
                  justifyContent="space-between"
                >
                  <Text fontSize="18px" fontWeight="500">
                    Advertised Courses
                  </Text>
                  <Link
                    fontWeight="500"
                    color="#EC3337"
                    fontSize="16px"
                    onClick={() => navigate(courseRoutes.advertisedCourses)}
                  >
                    See All
                  </Link>
                </Flex>
                <Grid
                  templateColumns={{
                    lg: "repeat(3, 1fr)",
                    md: "repeat(2, 1fr)",
                    sm: "repeat(1, 1fr)",
                    base: "repeat(1, 1fr)",
                  }}
                  mx="auto"
                  width="87%"
                  bg="white"
                  justifyContent="space-between"
                  pb="40px"
                  gap="0.6rem"
                >
                  {advertisedCourses.length > 0 ? (
                    advertisedCourses.slice(0, 3).map((each, index) => (
                      <GridItem
                        key={index}
                        width="100%"
                        boxShadow="0px 3.50207px 7.87967px rgba(51, 49, 49, 0.09)"
                        bg="white"
                      >
                        {each.course.cover_image ? (
                          <Image
                            objectFit="cover"
                            objectPosition="center"
                            height="170px"
                            width="100%"
                            src={each.course.cover_image}
                          />
                        ) : (
                          <Image
                            objectFit="cover"
                            objectPosition="center"
                            height="170px"
                            width="100%"
                            src={closeshot}
                          />
                        )}
                        <Box
                          width="90%"
                          mx="auto"
                          mt="21px"
                          mb="27px"
                          // height={"100%"}
                          // display={"flex"}
                          // flexDirection={"column"}
                        >
                          <Text
                            mb="15px"
                            color="#616161"
                            fontSize="14px"
                            fontWeight="400"
                            textTransform={"capitalize"}
                          >
                            {each.course.name.toLowerCase()}
                          </Text>
                          <Flex justifyContent="space-between">
                            <Text
                              px="15px"
                              fontSize="10px"
                              pt="3px"
                              bg=" #EC3337"
                              borderRadius="7px"
                              color="white"
                            >
                              {/* In 2 days */}
                              {moment(each.admission_start).fromNow()}
                            </Text>
                            <Text fontSize="16px" fontWeight="600">
                              N{each.course.cost}
                            </Text>
                          </Flex>
                        </Box>
                      </GridItem>
                    ))
                  ) : (
                    <GridItem colSpan={[2,2,3,3]}>
                      <Box mx="auto" width={"70px"} height="100px">
                        <Image src={empty2} />
                      </Box>
                      <Text
                        textAlign="center"
                        fontWeight="600"
                        fontSize="30px"
                        color="#353535"
                      >
                        No Advertised Courses
                      </Text>
                      <Text color="#353535" textAlign="center" fontSize="14px">
                        Advertised courses will show up here..
                      </Text>
                    </GridItem>
                  )}

                  
                </Grid>
              </Box>
            </Box>
            {isBadge && (
              <Portal>
                {" "}
                <ViewUserBadges
                  isOpenBadge={isBadge}
                  onClosed={setIsBade}
                  isBadge={isBadge}
                  badges={userBadges}
                />{" "}
              </Portal>
            )}
          </Flex>
        </>
      )}
    </>
  );
};

export default Dashboard;
